export interface ICrosshairSettingsProps {
    initialCode: string;
    onCodeChange?: (code: string) => void;
}

export enum CrosshairCanvasDisplayEnum {
    Preview,
    General,
    Primary,
    Advanced,
    Sniper,
    BackgroundEdit
}

export interface ICrosshairCanvasProps {
    code?: string;
    name?: string;
    displaySetting: CrosshairCanvasDisplayEnum;
    bgStyle?: string;
    onBgSelected?: () => void;
    crosshairId?: number;
    /** URL segment for the detail page. Falls back to the id when absent. */
    crosshairSlug?: string;
    favoriteCount?: number;
    isFavorited?: boolean;
    onFavoriteClick?: (id: number) => void;
    /** When false, preview tiles do not navigate (e.g. background grid on detail page). Default true. */
    previewNavigate?: boolean;
    /** When false, heart/favorite control is hidden on previews. Default true. */
    showFavoriteButton?: boolean;
}

export interface IColorOption {
    text: string;
    value: string;
    unicode: string;
    isValid?: boolean;
    customUnicode?: string;
}

export interface IPageProps {
    clearSearchValue?: () => void;
    searchValue: string;
}

export interface ICrosshairConfig {
    id: number;
    name: string;
    /** URL segment used by /valorant-crosshair/:slug. */
    slug: string;
    code: string;
    isPro: boolean;
    isFun: boolean;
    favoriteCount: number;
    isFavorited: boolean;
    /** Set when crosshair is not yet public: pending | rejected. Null/omitted when live in catalog. */
    submissionStatus?: string | null;
    /** Detail responses only — whether search engines may index this page (CrosshairIndexing.cs). */
    indexable?: boolean;
    /** Detail responses only — slug of the page this one canonicalises to; null when it is its own. */
    canonicalSlug?: string | null;
    /** Detail responses only — other approved crosshairs with an identical import code. */
    sameCode?: { id: number; name: string; slug: string }[];
}